import { createBrowserHistory } from 'history';

export default createBrowserHistory({ basename: process.env.PUBLIC_URL });